/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';

const FooterArrows = () => {

    return (
        <div className="footerArrows">
            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="234.298" height="213.382" viewBox="0 0 234.298 213.382">
                <defs>
                    <clipPath id="clip-path">
                    <rect id="Rectangle_5" width="234.298" height="213.382" transform="translate(-50 5065.666)" fill="none"/>
                    </clipPath>
                </defs>
                <g id="Group_7" transform="translate(50 -5065.666)">
                    <g id="Group_6" clipPath="url(#clip-path)">
                    <g id="Group_5">
                        <path id="footerArrow_1" d="M100.034,5280.37l-1.716-1.322,70.4-91.245L71.9,5059.256l1.73-1.3,97.809,129.87Z" fill="#d6d8e0"/>
                        <path id="footerArrow_2" d="M68.78,5280.37l-1.716-1.322,70.4-91.245L40.643,5059.256l1.73-1.3,97.809,129.87Z" fill="#d6d8e0"/>
                        <path id="footerArrow_3" d="M35.822,5280.37l-1.716-1.322,70.4-91.245L7.685,5059.256l1.73-1.3,97.809,129.87Z" fill="#d6d8e0"/>
                        <path id="footerArrow_4" d="M3.212,5280.37,1.5,5279.048l70.4-91.245-96.816-128.547,1.73-1.3,97.809,129.87Z" fill="#d6d8e0"/>
                        <path id="footerArrow_5" d="M-32.93,5281.911l-1.717-1.322,70.4-91.245L-61.067,5060.8l1.73-1.3,97.809,129.869Z" fill="#d6d8e0"/>
                    </g>
                    </g>
                </g>
                </svg>
        </div>
    );
}

export default FooterArrows;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/FooterArrows.jsx